export default __webpack_public_path__ + "static/hero-votecompass-fr-61c922306e1747c37279e8950489c9d5.png";